import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, addOnInvalidateHandler, invalidateResource } from "kea-resource";
import { Tarifa } from "../simple";
import { MatrizTarifa, } from "./matriztarifa";
import { ConfigSistema } from "./configsistema";
import { onCambioTarifa } from 'app/resources/items/tarifaupdate';
const controller = rpcController("Cotizador");

export const Cotizador = cacheResource({

    /**
     * Borra un ticket
     * @param id 
     */
    Cotizar: async (entity: models.CotizadorModel): Promise<models.CotizadorModelDTO> => await controller("Cotizar", {}, entity),
});


//Invalidamos la cotización cada vez que cambie la tarifa
onCambioTarifa.subscribe(() => invalidateResource(Cotizador));


// WEBPACK FOOTER //
// ./app/resources/items/cotizador.ts